
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Check, X } from "lucide-react";

interface UnauthenticatedFeaturesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnauthenticatedFeaturesDialog = ({
  isOpen,
  onClose,
}: UnauthenticatedFeaturesDialogProps) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/auth");
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Funksionalitet i kufizuar për përdoruesit e paregjistruar
          </DialogTitle>
          <DialogDescription>
            Ju mund të krijoni shpallje pa u regjistruar, por do të keni qasje të kufizuar në disa funksione.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <h3 className="font-medium">Si përdorues i paregjistruar, NUK mund të:</h3>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <X className="h-5 w-5 text-red-500 shrink-0 mt-0.5" />
              <span>Përdorni funksionet e AI për titull dhe përshkrim të shpalljes</span>
            </li>
            <li className="flex items-start gap-2">
              <X className="h-5 w-5 text-red-500 shrink-0 mt-0.5" />
              <span>Merrni mesazhe direkte nga blerësit (kontakti vetëm me email)</span>
            </li>
            <li className="flex items-start gap-2">
              <X className="h-5 w-5 text-red-500 shrink-0 mt-0.5" />
              <span>Keni një faqe profili me vlerësime</span>
            </li>
            <li className="flex items-start gap-2">
              <X className="h-5 w-5 text-red-500 shrink-0 mt-0.5" />
              <span>Shitni me opsionin "Bli Tani" për pagesë të menjëhershme</span>
            </li>
          </ul>

          <h3 className="font-medium mt-6">Si përdorues i paregjistruar, mund të:</h3>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 shrink-0 mt-0.5" />
              <span>Krijoni shpallje me informacionin bazë</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 shrink-0 mt-0.5" />
              <span>Merrni kontakte me email nga blerësit e interesuar</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 shrink-0 mt-0.5" />
              <span>Ngarkoni deri në 5 imazhe për shpalljen tuaj</span>
            </li>
          </ul>
        </div>

        <DialogFooter className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:justify-between">
          <Button variant="outline" onClick={onClose}>
            Vazhdo pa regjistrim
          </Button>
          <Button onClick={handleSignUp}>
            Regjistrohu tani
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnauthenticatedFeaturesDialog;
